import React from 'react'
import { imgProxy } from '../../utils/helpers'

// Styles
import './styles.scss'

export default ({ gallery }: { gallery: string[] }) => {
  return (
    <div className={'expert-gallery-block'}>
      {gallery.map((image, index) => (
        <div
          key={`expert-gallery-${index}`}
          className={'expert-gallery-block__item'}
        >
          <div
            className={'expert-gallery-block__item-outer'}
            data-fancybox={'expert-gallery'}
            data-src={image}
          >
            <img src={imgProxy(image, 400, 400)} />
          </div>
        </div>
      ))}
    </div>
  )
}
